import { motion } from "framer-motion";
import { useState } from "react";
import QuoteDialog from "@/components/QuoteDialog";
import ThemeToggle from "@/components/ThemeToggle";

const NAV = [
  { label: "Network", href: "#network" },
  { label: "Products", href: "#products" },
  { label: "Why Us", href: "#why" },
  { label: "Industries", href: "#industries" },
  { label: "Partners", href: "#partners" },
];

export default function Nav() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 border-b site-header-bg"
      style={{ backdropFilter: "blur(18px)", borderColor: "var(--hairline)" }}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/omnicoretek-logo.png"
            alt="OmniCoreTek logo"
            data-testid="brand-logo-image"
            className="h-8 w-8 object-contain"
            style={{ filter: "drop-shadow(0 0 6px rgba(0,229,255,0.35))" }}
          />
          <span className="font-display text-[16px] tracking-tight">
            Omni<span className="text-electric-500">Core</span>Tek
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] text-slate-300 hover:text-white electric-underline"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <motion.button
            data-testid="header-request-quote-button"
            onClick={() => setQuoteOpen(true)}
            whileTap={{ scale: 0.97 }}
            className="btn-electric text-[13px] font-medium px-4 py-2 rounded-full"
          >
            Request Quote
          </motion.button>
        </div>
      </div>
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </header>
  );
}
